import {
  CreateFolderDto,
  DeleteFolderResponse,
  FolderContentsResponse,
  FolderDto,
  MoveFolderDto,
  RenameFolderDto,
} from "@repo/api/folder";
import { VideoSort } from "@repo/api/video";
import { AmplifilesClient } from "./api-client";

export class FolderApi {
  static async getFolderContents(
    teamExternalId: string,
    folderExternalId?: string,
    sort: VideoSort = "lastUpdated",
  ): Promise<FolderContentsResponse> {
    const url = folderExternalId
      ? `/team/${teamExternalId}/folder/${folderExternalId}`
      : `/team/${teamExternalId}/folder`;

    const response = await AmplifilesClient.instance.get(url, {
      params: { sort },
    });

    return FolderContentsResponse.parse(response.data);
  }

  static async createFolder(
    teamExternalId: string,
    data: CreateFolderDto,
  ): Promise<FolderDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/folder`,
      data,
    );

    return FolderDto.parse(response.data);
  }

  static async renameFolder(
    teamExternalId: string,
    folderExternalId: string,
    data: RenameFolderDto,
  ): Promise<FolderDto> {
    const response = await AmplifilesClient.instance.patch(
      `/team/${teamExternalId}/folder/${folderExternalId}`,
      data,
    );

    return FolderDto.parse(response.data);
  }

  static async moveFolder(
    teamExternalId: string,
    folderExternalId: string,
    data: MoveFolderDto,
  ): Promise<FolderDto> {
    const response = await AmplifilesClient.instance.patch(
      `/team/${teamExternalId}/folder/${folderExternalId}/move`,
      data,
    );

    return FolderDto.parse(response.data);
  }

  static async deleteFolder(
    teamExternalId: string,
    folderExternalId: string,
  ): Promise<DeleteFolderResponse> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/folder/${folderExternalId}`,
    );

    return DeleteFolderResponse.parse(response.data);
  }
}
